module.exports = __webpack_public_path__ + "static/media/bowl2.58cfd4ff.jpg";